module.exports = __webpack_public_path__ + "img/kh.9042ee6b.svg";